import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'CE Progress|Voucher Progress';
type CPVoucherFeeBatchesLocs =
	| 'CPCeVoucherProgressTitle'
	| 'CPCeVoucherProgressName'
	| 'CPCeVoucherProgressTotalFees'
	| 'CPCeVoucherProgressFeesPaid'
	| 'CPCeVoucherProgressFeesRemaining'
	| 'CPCeVoucherProgressFeeDueDate'
	| 'CPCeVoucherProgressCompletionPercentage'
	| 'CPCeVoucherProgressViewButton';

export const cPVoucherFeeBatchesLocs: LocDefs<CPVoucherFeeBatchesLocs> = {
	CPCeVoucherProgressTitle: {
		defaultValue: 'Continuing Education Voucher Progress',
		description: 'Title for the continuing education voucher progress page.',
		displayPath: `${dpRoot}|Title`,
		displayType: 'Title',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'CP',
	},
	CPCeVoucherProgressName: {
		defaultValue: 'Name',
		description: 'Label for the name input field.',
		displayPath: `${dpRoot}|Name`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'CP',
	},
	CPCeVoucherProgressTotalFees: {
		defaultValue: 'Total Fees',
		description: 'Label for the total fees input field.',
		displayPath: `${dpRoot}|Total Fees`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'CP',
	},
	CPCeVoucherProgressFeesPaid: {
		defaultValue: 'Fees Paid',
		description: 'Label for the fees paid input field.',
		displayPath: `${dpRoot}|Fees Paid`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'CP',
	},
	CPCeVoucherProgressFeesRemaining: {
		defaultValue: 'Fees Remaining',
		description: 'Label for the fees remaining input field.',
		displayPath: `${dpRoot}|Fees Remaining`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'CP',
	},
	CPCeVoucherProgressFeeDueDate: {
		defaultValue: 'Fee Due Date',
		description: 'Label for the fee due date input field.',
		displayPath: `${dpRoot}|Fee Due Date`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'CP',
	},
	CPCeVoucherProgressCompletionPercentage: {
		defaultValue: 'Completion Percentage',
		description: 'Label for the completion percentage input field.',
		displayPath: `${dpRoot}|Completion Percentage`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'CP',
	},
	CPCeVoucherProgressViewButton: {
		defaultValue: 'View Credential',
		description: 'Label for the view button.',
		displayPath: `${dpRoot}|View Button`,
		displayType: 'Button',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'CP',
	},
};

export const cPVoucherFeeBatchesLocKeys =
	MapLocKeys<CPVoucherFeeBatchesLocs>(cPVoucherFeeBatchesLocs);

export type CPVoucherFeeBatchesLocKeys = typeof cPVoucherFeeBatchesLocKeys;
